import type { StateStorage } from 'zustand/middleware'
import { createJSONStorage } from 'zustand/middleware'

/**
 * localStorage-backed persist storage with a legacy-key adoption shim.
 *
 * All persisted stores use the `chromaframe-*` prefix and carry a `version`.
 * Stores that previously lived under another prefix (the `aframe-*` era)
 * adopt their old key on first read: if the new key is absent and a legacy
 * key exists, its value is copied forward so nothing orphans silently.
 */
function legacyAdoptingStorage(legacyNames: string[]): StateStorage {
  return {
    getItem: (name) => {
      const current = localStorage.getItem(name)
      if (current !== null) return current
      for (const legacy of legacyNames) {
        const value = localStorage.getItem(legacy)
        if (value !== null) {
          localStorage.setItem(name, value)
          localStorage.removeItem(legacy)
          return value
        }
      }
      return null
    },
    setItem: (name, value) => localStorage.setItem(name, value),
    removeItem: (name) => localStorage.removeItem(name),
  }
}

/** Persist storage for a store named `name`, adopting `legacyNames` first. */
export function persistStorage(name: string, legacyNames: string[] = []) {
  void name
  return createJSONStorage(() => legacyAdoptingStorage(legacyNames))
}
